import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'sellWelcome',
    inject: ['$eventBus'],
    components: {
        mvtInputGeo,
        mvtWelcome,
    },
    mounted() {
        var that = this;
        this.$eventBus.$on('eventbus-hotlead-userid', function (uId) {
            that.claimHome(uId);
        });
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        ...mapGetters('sell', ['sell']),
        imgSrc() {
            return this.sell.pageImage || `${this.glb.cdnUrl}vimages/agent-customer.webp`;
        },
        local() {
            return this.glb.geo && this.glb.geo.city ? `${this.glb.geo.city}, ${this.glb.geo.state}` : 'Local';
        },
    },
    methods: {
        ...mapActions('glb', ['addClaimedHome']),
        getClaimedHomeAddress(geoInfo) {
            this.$eventBus.$emit('eventbus-search-address', {
                text: geoInfo.text,
                geo: geoInfo.geo,
                getClaimedHome: true,
                getFirstListing: this.getFirstListing,
            });
        },
        getFirstListing(data) {
            var that = this;
            if (data && data.listings && data.listings.length) {
                var listing = data.listings[0];
                this.options = {
                    propertyId: listing.propertyId,
                };
                that.$eventBus.$emit('dialog-center', {
                    name: 'mvtHotleadForm',
                    trigger: that.$options.name,
                    opt: {
                        hotleadSup: 'GET STARTED',
                        hotleadTitle: `Message an Agent About Selling`,
                        hotleadType: this.glb.geo && this.glb.geo.city ? 'LocalSellPageSell' : 'ConnectWithSellerAgent',
                        buttonText: this.molang('dpp.hotleadForm.go'),
                        propertyId: listing.propertyId,
                        propertyData: listing,
                        showComment: true,
                        isAgentSell: true,
                        noSecondaryLead: true,
                    },
                });
            } else {
                this.$eventBus.$emit('dialog-center', { name: 'mvtGeoSearchResult', trigger: this.$options.name, opt: {} });
            }
        },
        claimHome(uId) {
            var that = this;
            // for non logged in user take user id from hotlead
            if (!(this.glb.user && this.glb.user.id)) {
                this.options.userId = uId;
                this.options.noLoginReq = 1;
            }

            this.addClaimedHome(this.options).then(function (res) {
                if (res) {
                    that.$eventBus.$emit('eventbus-reset-inputgeo');
                }
                that.$eventBus.$emit('eventbus-dialog-close');
            });
        },
    },
    data: function () {
        return {
            geoInfo: {
                text: '',
                geo: null,
            },
        };
    },
    watch: {
        geoInfo(newVal) {
            if (newVal) {
                this.getClaimedHomeAddress(newVal);
            }
        },
    },

    beforeUnmount() {
        this.$eventBus.$off('eventbus-hotlead-userid');
    },
};
